import LandingPage from './components/LandingPage';
import './App.css';

function App() {
  return (
    <div className="App">
     <LandingPage/>
    </div>
  );
}

export default App;
